import { CheckCircle } from "lucide-react";

const RXTHardwareSpecs = () => {
  const hardwareSpecs = [
    {
      title: "Display & Interface",
      items: [
        "4\" (720×720) and 6\" (1440×720) touch panel options",
        "500 nits brightness with 160° viewing angle",
        "Proximity sensor and ambient light sensor on all models",
        "Front and rear RGB LED indicators",
        "NFC support on all models"
      ]
    },
    {
      title: "Audio & Video System",
      items: [
        "Dante™/AES67 audio networking on all models",
        "SmartSpeak™ beamforming microphones on all models",
        "WordGate™ AI camera tracking on all models",
        "Dedicated 800MHz Audio DSP",
        "4K30 H.264 & RTSP streaming decoder",
        "Built-in 4W speaker & 3.5mm headphone output"
      ]
    },
    {
      title: "Connectivity & Power",
      items: [
        "DV models: USB-C & Mini-HDMI inputs, USB-C display output",
        "DV models: USB-C 100W power pass-through for laptop charging",
        "Gigabit Ethernet with PoE+ support on all models",
        "Six Core 2.0GHz processor with Linux™"
      ]
    }
  ];

  return (
    <div className="mb-16">
      <h2 className="text-2xl font-bold mb-8">Hardware Specifications</h2>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {hardwareSpecs.map((spec, index) => (
          <div key={index} className="bg-card rounded-lg p-6 border shadow-sm">
            <h3 className="text-lg font-semibold mb-3 text-[#069E50]">{spec.title}</h3>
            <ul className="space-y-2">
              {spec.items.map((item, itemIndex) => (
                <li key={itemIndex} className="flex items-start gap-2">
                  <CheckCircle className="h-4 w-4 text-[#069E50] mt-0.5 flex-shrink-0" />
                  <span className="text-sm text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RXTHardwareSpecs;
